import { defer, Observable } from 'rxjs';
import { map } from 'rxjs';
import { EpicDeps } from 'src/core/engine';
import { ApolloClient } from '@apollo/client';

import getCustomerCartQuery from '../queries/getCustomerCartId.graphql';
import { getCustomerCartId } from '../queries/__generated__/getCustomerCartId';

export function fetchMineCartId(deps: EpicDeps): Observable<string> {
    return getMineCartIdAjax(deps).pipe(map((resp) => resp.id));
}

function getMineCartIdAjax(deps: EpicDeps) {
    const client = deps.client as ApolloClient<any>;
    return defer(() => {
        return client.query<getCustomerCartId>({
            query: getCustomerCartQuery,
            fetchPolicy: 'no-cache',
            operationName: 'getCustomerCartId',
        } as any);
    }).pipe(map((x) => x.data?.getCustomerCartId || 'unknown'));
}
